/**
 * 堆栈：先进后出
 */
export class Stack<T> {
  private stack: Array<T>;

  constructor() {
    this.stack = new Array<T>();
  }

  public clear() {
    this.stack = new Array<T>();
  }

  public isEmpty(): boolean {
    return !this.stack.length;
  }

  public peek(): T | null {
    const len = this.size();
    if (len > 1) {
      return this.stack[len - 1];
    }
    return null;
  }

  public print(): void {
    console.log(this.stack.toString());
  }

  public pop(): T | null {
    const data = this.stack.pop();
    if (!data) {
      return null;
    }
    return data;
  }

  public push(item: T) {
    this.stack.push(item);
  }

  public size(): number {
    return this.stack.length;
  }
}
